import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout/Layout.jsx';
import Login from './components/Login/Login.jsx';
import Home from './components/Home/Home.jsx';
import About from './components/About/About.jsx';
import Contact from './components/Contact/Contact.jsx';
import Register from './components/Register/Register.jsx';
import People from './components/People/People.jsx';
import Tv from './components/Tv/Tv.jsx';
import Movies from './components/Movies/Movies.jsx';
import NotFound from './components/NotFound/NotFound.jsx';
import { useEffect, useState } from 'react';
import Profile from './components/Profile/Profile.jsx';
import ItemDetails from './components/ItemDetails/ItemDetails.jsx';
import { Offline } from 'react-detect-offline';

function App() {
  const [userData, setUserData] = useState(null);

  const [isLogged, setIsLogged] = useState(true);

  function saveUserData() {
    let newUserData = localStorage.getItem('user');
    setUserData(newUserData);
  }

  useEffect(() => {
    // if(localStorage.getItem('user')!== null){
    saveUserData();
    // }
  }, [])

  let routers = createBrowserRouter([
    {
      path: '/', element: <Layout userData={userData} setUserData={setUserData} isLogged={isLogged} setIsLogged={setIsLogged} />, children: [
        { index: true, element: isLogged ? <Home setIsLogged={setIsLogged} isLogged={isLogged} /> : <Login saveUserData={saveUserData} isLogged={isLogged} setIsLogged={setIsLogged} /> },
        { path: 'register', element: <Register /> },
        { path: 'login', element: <Login saveUserData={saveUserData} isLogged={isLogged} setIsLogged={setIsLogged} /> },
        { path: 'profile', element: isLogged ? <Profile isLogged={isLogged} setIsLogged={setIsLogged} /> : <Login saveUserData={saveUserData} isLogged={isLogged} setIsLogged={setIsLogged} /> },
        { path: 'about', element: <About /> },
        { path: 'contact', element: isLogged ? <Contact isLogged={isLogged} setIsLogged={setIsLogged} /> : <Login saveUserData={saveUserData} isLogged={isLogged} setIsLogged={setIsLogged} /> },
        { path: 'people', element: isLogged ? <People isLogged={isLogged} setIsLogged={setIsLogged} /> : <Login saveUserData={saveUserData} isLogged={isLogged} setIsLogged={setIsLogged} /> },
        { path: 'tv', element: isLogged ? <Tv /> : <Login /> },
        { path: 'movies', element: isLogged ? <Movies isLogged={isLogged} setIsLogged={setIsLogged} /> : <Login saveUserData={saveUserData} isLogged={isLogged} setIsLogged={setIsLogged} /> },
        { path: 'itemdetails/:id/:media_type', element: isLogged ? <ItemDetails isLogged={isLogged} setIsLogged={setIsLogged} /> : <Login saveUserData={saveUserData} isLogged={isLogged} setIsLogged={setIsLogged} /> },
        { path: '*', element: <NotFound /> }
      ]
    }
  ])
  return <>

    <Offline className='z-3'><div className="offline bg-danger ">You Currently Offline</div></Offline>

    <RouterProvider router={routers} />
  </>
}

export default App;
